import React, { useState , useContext} from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { User, MessageSquare, Clock, File, MessageCircle, UserMinus, Headphones, UserCheck, ArrowLeft } from 'react-feather';
import { ConfigContext } from '../../../Api/global/ApiContext';
import { addNewQaList, getTeachers } from '../../../Api/apiUtils';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { MixpanelEvents, trackEvent } from '../../../utils/mixpanelTracking';
import { Page, PageHeader, Card, Button, Field, TextInput, SearchInput, Select, EmptyState } from '../../../ui';
import './qaPolicy.scss';


interface Teacher {
    teacherId: any;
    teacherName: string;
    credentialId: any;

  }
const AddQaList: React.FC = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        // teacherId: '',
        teacherName: '',
        teacherCategory: '',
        studentName: '',
        sessionDate: '',
        course: '',
        ageGroup: '',
        auditDate: '',
        feedbackStatus: '',
        feedbackLink: '',
        observation: '',
 
        Opening: {
            startedOnTime: '',
            internetConnection: '',
            greetingIntroduction: '',
        },
        Feedback: {
            constructiveFeedbackWhileDiscussingTheAssessmentAssignmentOfThePreviousClass: '',
            aOIWithExamples: '',
            addressTheStudentByTheirName: '',
        },
        RapportBuilding: {
            engagementLevel: '',
            madeTheStudentFeelComfortable: '',
        },
        communicationSkillsAndSoftskills: {
            deadAirFumblingFillersUnnecessaryMuteNeedsToBeAvoided: '',
            casualApproachToneUsageOfSlangLanguage: '',
            acknowledgment: '',
            activeListening: '',
            interruption: '',
            energyLevel: '',
            rateOfSpeech: '',
        },
        Closing: {
            customerDelight: '',
            DoubtsSolvingQueryResolution: '',
            energeticAndPositiveClosing: '',
            disconnectionAfterTheStudent: '',
        },
        TechGadgets: {
            mic: '',
            headphones: '',
            jacket: '',
            videoQualityCamAngleBodyLanguageBackground: '',
            practiceStudio: '',
            pleaseSpecifyTheInstrumentUsed: '',
        },
        Presentation: {
            appropriatelyDressed: '',
            videoOn: '',
            rudeSarcasticIntimidatingBehaviourUnprofessionalism: '',
        },
        Time: {
            sessionAsPerStandardTime: '',
        },
    });
    const [isLoading, setIsLoading] = useState(false);
    const [teachers, setTeachers] = useState<Teacher[]>([]);

    const config = useContext(ConfigContext);
    const { states = [], genders = [], timezones = [], ageGroups = [], countryCodes = []  , courses = [], languages=[]} = useContext(ConfigContext) || {};
    const [searchQuery, setSearchQuery] = useState("");
const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedTeacher, setSelectedTeacher] = useState("");
const [selectedTeacherId, setSelectedTeacherId] = useState<string>("");


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const handleSearch = async () => {
  const searchPayload = { name: searchQuery };
  await fetchTeachers(searchPayload);
  setIsModalOpen(true); 
};
const courseOptions = courses.map((course: any) => ({
    value: course.name,
    label: course.name,
  }));

  // Score fields accept 0 to 5; shown as the field's error under the input.
  const scoreError = (value: string) => {
    const num = parseFloat(value);
    if (value !== "" && (isNaN(num) || num < 0 || num > 5)) {
        return "Please enter a value between 0 to 5";
    }
    return undefined;
};

// Function to calculate total score from all numeric fields
const calculateTotalScore = () => {
    let total = 0;
    
    // Helper function to sum numeric values from nested objects
    const sumNumericValues = (obj: any): number => {
        let sum = 0;
        for (const key in obj) {
            if (typeof obj[key] === "object" && obj[key] !== null) {
                sum += sumNumericValues(obj[key]);
            } else if (typeof obj[key] === "string" && obj[key].trim() !== "") {
                const num = parseFloat(obj[key]);
                if (!isNaN(num) && num >= 0 && num <= 5) {
                    sum += num;
                }
            }
        }
        return sum;
    };

    // Calculate sum from all sections
    total += sumNumericValues(formData.Opening);
    total += sumNumericValues(formData.Feedback);
    total += sumNumericValues(formData.RapportBuilding);
    total += sumNumericValues(formData.communicationSkillsAndSoftskills);
    total += sumNumericValues(formData.Closing);
    total += sumNumericValues(formData.TechGadgets);
    total += sumNumericValues(formData.Presentation);
    total += sumNumericValues(formData.Time);

    return total;
};

// Component to display total score
const TotalScoreDisplay = () => {
    const total = calculateTotalScore();
    return (
        <div className={total > 100 ? "qa-total qa-total--over" : "qa-total"} role="status" aria-live="polite">
            <strong className="ds-num">Total Score: {total}/100</strong>
            {total > 100 && (
                <p>Total score exceeds 100! Please reduce some values.</p>
            )}
        </div>
    );
};


const handleAddTeacher = () => {
    if (selectedTeacher) {
      setFormData((prevState) => ({
        ...prevState,
        teacherName: selectedTeacher, 
      }));
      setIsModalOpen(false); 
      setSelectedTeacher(""); 
    } else {
      toast.warning("Please select a teacher.");
    }
  };
  
  // Function to toggle modal
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

    const fetchTeachers = async (searchPayload: {name?: string, emailId?: string, mobileNumber?: string } = {}) => {
        try {
          const fetchedTeachers = await getTeachers(0, 200, searchPayload);
          if (Array.isArray(fetchedTeachers)) {
            setTeachers(fetchedTeachers);
            const credentialIds = fetchedTeachers.map((teacher) => teacher.credentialId);
            localStorage.setItem("TeachercredentialIds", JSON.stringify(credentialIds));
          } else {
            console.error("Fetched data is not an array:", fetchedTeachers);
          }
        } catch (error) {
          console.error("There was an error fetching the teacher data!", error);
        }
      };

      const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
    

        const keys = name.split(".");
            setFormData((prevState) => {
          const newState = { ...prevState };
    

          let currentLevel: any = newState; 
          for (let i = 0; i < keys.length - 1; i++) {
            if (!currentLevel[keys[i]]) {
              currentLevel[keys[i]] = {}; 
            }
            currentLevel = currentLevel[keys[i]];
          }
    
          currentLevel[keys[keys.length - 1]] = value;
    
          return newState;
        });
      };
    

    //   // Check basic information
    //   // if (!formData.teacherId || !formData.teacherName || !formData.teacherCategory || 
    //   //     !formData.studentName || !formData.sessionDate || !formData.course || 
    //   //     !formData.ageGroup || !formData.auditDate || !formData.feedbackStatus || 
    //   //     !formData.feedbackLink || !formData.observation) {
    //   //   toast.error('Please fill in all basic information fields');
    //   //   return false;
    //   // }

    //   // Check Opening section
    //   // if (!formData.Opening.startedOnTime || !formData.Opening.internetConnection || 
    //   //     !formData.Opening.greetingIntroduction) {
    //   //   toast.error('Please fill in all Opening section fields');
    //   //   return false;
    //   // }

    //   // Check Feedback section
    //   // if (!formData.Feedback.constructiveFeedbackWhileDiscussingTheAssessmentAssignmentOfThePreviousClass || 
    //   //     !formData.Feedback.aOIWithExamples || !formData.Feedback.addressTheStudentByTheirName) {
    //   //       toast.error('Please fill in all Feedback section fields');
    //   //   return false;
    //   // }

    //   // Check Rapport Building section
    //   // if (!formData.RapportBuilding.engagementLevel || 
    //   //     !formData.RapportBuilding.madeTheStudentFeelComfortable) {
    //   //       toast.error('Please fill in all Rapport Building section fields');
    //   //   return false;
    //   // }

    //   // Check Communication Skills section
    //   if (!formData.communicationSkillsAndSoftskills.deadAirFumblingFillersUnnecessaryMuteNeedsToBeAvoided || 
    //       !formData.communicationSkillsAndSoftskills.casualApproachToneUsageOfSlangLanguage || 
    //       !formData.communicationSkillsAndSoftskills.acknowledgment || 
    //       !formData.communicationSkillsAndSoftskills.activeListening || 
    //       !formData.communicationSkillsAndSoftskills.interruption || 
    //       !formData.communicationSkillsAndSoftskills.energyLevel || 
    //       !formData.communicationSkillsAndSoftskills.rateOfSpeech) {
    //         toast.error('Please fill in all Communication Skills section fields');
    //     return false;
    //   }

    //   // Check Closing section
    //   if (!formData.Closing.customerDelight || !formData.Closing.DoubtsSolvingQueryResolution || 
    //       !formData.Closing.energeticAndPositiveClosing || !formData.Closing.disconnectionAfterTheStudent) {
    //         toast.error('Please fill in all Closing section fields');
    //     return false;
    //   }

    //   // Check Tech & Gadgets section
    //   if (!formData.TechGadgets.mic || !formData.TechGadgets.headphones || !formData.TechGadgets.jacket || 
    //       !formData.TechGadgets.videoQualityCamAngleBodyLanguageBackground || 
    //       !formData.TechGadgets.practiceStudio || !formData.TechGadgets.pleaseSpecifyTheInstrumentUsed) {
    //         toast.error('Please fill in all Tech & Gadgets section fields');
    //     return false;
    //   }

    //   // Check Presentation section
    //   if (!formData.Presentation.appropriatelyDressed || !formData.Presentation.videoOn || 
    //       !formData.Presentation.rudeSarcasticIntimidatingBehaviourUnprofessionalism) {
    //         toast.error('Please fill in all Presentation section fields');
    //     return false;
    //   }

    //   // Check Time section
    //   if (!formData.Time.sessionAsPerStandardTime) {
    //     toast.error('Please fill in the Time section field');
    //     return false;
    //   }

    //   return true;
    // }
    const isFormValid = () => {
      const missingFields: string[] = [];

      // Helper to check nested objects
      const checkFields = (obj: any, parentKey: string = '') => {
        let isValid = true;
        for (const key in obj) {
          const fullKey = parentKey ? `${parentKey}.${key}` : key;
          if (typeof obj[key] === "object" && obj[key] !== null) {
            if (!checkFields(obj[key], fullKey)) {
              isValid = false;
            }
          } else {
            const value = typeof obj[key] === "string" ? obj[key].trim() : obj[key];
            if (value === "" || value === null || value === undefined) {
              missingFields.push(fullKey);
              isValid = false;
            }
          }
        }
        return isValid;
      };

      const {
        Opening,
        Feedback,
        RapportBuilding,
        communicationSkillsAndSoftskills,
        Closing,
        TechGadgets,
        Presentation,
        Time,
        ...basicFields
      } = formData;

      // Check basic fields
      for (const key in basicFields) {
        const value = typeof basicFields[key as keyof typeof basicFields] === "string"
          ? (basicFields[key as keyof typeof basicFields] as string).trim()
          : basicFields[key as keyof typeof basicFields];
        if (value === "" || value === null || value === undefined) {
          missingFields.push(key);
        }
      }

      // Check all nested objects
      checkFields(Opening, 'Opening');
      checkFields(Feedback, 'Feedback');
      checkFields(RapportBuilding, 'RapportBuilding');
      checkFields(communicationSkillsAndSoftskills, 'communicationSkillsAndSoftskills');
      checkFields(Closing, 'Closing');
      checkFields(TechGadgets, 'TechGadgets');
      checkFields(Presentation, 'Presentation');
      checkFields(Time, 'Time');

      if (missingFields.length > 0) {
        // toast.error(`Missing fields: ${missingFields.join(', ')}`);
        return false;
      }

      // Check total score validation
      const totalScore = calculateTotalScore();
      if (totalScore > 100) {
        return false;
      }

      return true;
    };

    const handleSubmit = async () => {
      // Check total score first
      const totalScore = calculateTotalScore();
      if (totalScore > 100) {
        toast.error(`Total score (${totalScore}) exceeds 100. Please reduce some values to proceed.`);
        return;
      }

      if (!isFormValid()) {
        toast.error("All fields are mandatory. Please fill in all fields.");
        return;
      }
    

      const {
        Opening,
        Feedback,
        RapportBuilding,
        communicationSkillsAndSoftskills,
        Closing,
        TechGadgets,
        Presentation,
        Time,
        ...basicFields
      } = formData;

      const updatedFormData = {
        ...basicFields,
        teacherId: selectedTeacherId,
        payload: [
          {
            Opening,
            Feedback,
            RapportBuilding,
            communicationSkillsAndSoftskills,
            Closing,
            TechGadgets,
            Presentation,
            Time
          }
        ]
      };
      
      setIsLoading(true);
      try {
        await addNewQaList(updatedFormData);
        setIsLoading(false);
       toast.success('QA List added successfully');
       trackEvent(MixpanelEvents.QA_ADMIN_AUDIT_CREATED, {
         source: "qa_policy_form",
         teacherId: selectedTeacherId != null ? String(selectedTeacherId) : undefined,
       });
        navigate("/pages/qa-policy");
      } catch (error) {
        console.error("Error adding QA List:", error);
        setIsLoading(false);
        trackEvent(MixpanelEvents.QA_ADMIN_AUDIT_CREATE_FAILED, {
          source: "qa_policy_form",
          teacherId: selectedTeacherId != null ? String(selectedTeacherId) : undefined,
        });
      }
    };

    // Score sections. `name` is the dot path handleChange writes to; `type` and whether
    // the 0–5 check is shown are kept per field as they were.
    type ScoreField = { name: string; label: string; type: 'text' | 'number'; validate: boolean };
    const scoreSections: { title: string; icon: React.ReactNode; fields: ScoreField[] }[] = [
      {
        title: 'Opening',
        icon: <Clock size={18} aria-hidden />,
        fields: [
          { name: 'Opening.startedOnTime', label: 'Started on Time', type: 'text', validate: true },
          { name: 'Opening.internetConnection', label: 'Internet Connection', type: 'text', validate: true },
          { name: 'Opening.greetingIntroduction', label: 'Greeting/Introduction', type: 'text', validate: true },
        ],
      },
      {
        title: 'Feedback',
        icon: <MessageSquare size={18} aria-hidden />,
        fields: [
          { name: 'Feedback.constructiveFeedbackWhileDiscussingTheAssessmentAssignmentOfThePreviousClass', label: 'Assignment of the Previous Class', type: 'number', validate: true },
          { name: 'Feedback.aOIWithExamples', label: 'AOI with Examples', type: 'number', validate: true },
          { name: 'Feedback.addressTheStudentByTheirName', label: 'Address the Student by Their Name', type: 'number', validate: true },
        ],
      },
      {
        title: 'Rapport Building',
        icon: <File size={18} aria-hidden />,
        fields: [
          { name: 'RapportBuilding.engagementLevel', label: 'Engagement Level', type: 'text', validate: true },
          { name: 'RapportBuilding.madeTheStudentFeelComfortable', label: 'Made the Student Feel Comfortable', type: 'text', validate: true },
        ],
      },
      {
        title: 'Communication Skills and Soft Skills',
        icon: <MessageCircle size={18} aria-hidden />,
        fields: [
          { name: 'communicationSkillsAndSoftskills.deadAirFumblingFillersUnnecessaryMuteNeedsToBeAvoided', label: 'Dead Air/Fumbling/Fillers/Unnecessary Mute Needs to be Avoided', type: 'number', validate: false },
          { name: 'communicationSkillsAndSoftskills.casualApproachToneUsageOfSlangLanguage', label: 'Casual Approach/Tone, Usage of Slang Language', type: 'number', validate: true },
          { name: 'communicationSkillsAndSoftskills.acknowledgment', label: 'Acknowledgment', type: 'number', validate: true },
          { name: 'communicationSkillsAndSoftskills.activeListening', label: 'Active Listening', type: 'number', validate: true },
          { name: 'communicationSkillsAndSoftskills.interruption', label: 'Interruption', type: 'number', validate: true },
          { name: 'communicationSkillsAndSoftskills.energyLevel', label: 'Energy Level', type: 'number', validate: true },
          { name: 'communicationSkillsAndSoftskills.rateOfSpeech', label: 'Rate of Speech', type: 'number', validate: true },
        ],
      },
      {
        title: 'Closing',
        icon: <UserMinus size={18} aria-hidden />,
        fields: [
          { name: 'Closing.customerDelight', label: 'Customer Delight', type: 'number', validate: true },
          { name: 'Closing.DoubtsSolvingQueryResolution', label: 'Doubts Solving/Query Resolution', type: 'text', validate: true },
          { name: 'Closing.energeticAndPositiveClosing', label: 'Energetic and Positive Closing', type: 'text', validate: true },
          { name: 'Closing.disconnectionAfterTheStudent', label: 'Disconnection after the Student', type: 'text', validate: false },
        ],
      },
      {
        title: 'Tech & Gadgets',
        icon: <Headphones size={18} aria-hidden />,
        fields: [
          { name: 'TechGadgets.mic', label: 'Mic', type: 'text', validate: true },
          { name: 'TechGadgets.headphones', label: 'Headphones', type: 'text', validate: true },
          { name: 'TechGadgets.jacket', label: 'Jacket', type: 'text', validate: true },
          { name: 'TechGadgets.videoQualityCamAngleBodyLanguageBackground', label: 'Video Quality/Cam Angle/Body Language/Background', type: 'text', validate: true },
          { name: 'TechGadgets.practiceStudio', label: 'Practice Studio', type: 'text', validate: true },
          { name: 'TechGadgets.pleaseSpecifyTheInstrumentUsed', label: 'Instrument Used', type: 'text', validate: true },
        ],
      },
      {
        title: 'Presentation',
        icon: <UserCheck size={18} aria-hidden />,
        fields: [
          { name: 'Presentation.appropriatelyDressed', label: 'Appropriately Dressed', type: 'text', validate: true },
          { name: 'Presentation.videoOn', label: 'Video On', type: 'text', validate: true },
          { name: 'Presentation.rudeSarcasticIntimidatingBehaviourUnprofessionalism', label: 'Rude/Sarcastic/Intimidating Behaviour/Unprofessionalism', type: 'text', validate: true },
        ],
      },
      {
        title: 'Time',
        icon: <Clock size={18} aria-hidden />,
        fields: [
          { name: 'Time.sessionAsPerStandardTime', label: 'Session as per Standard Time', type: 'text', validate: true },
        ],
      },
    ];
    const scoreValue = (name: string): string => {
      const [group, key] = name.split('.');
      return (formData as any)[group]?.[key] ?? '';
    };
    const sectionTitle = (icon: React.ReactNode, title: string) => (
      <span className="qa-section-title">{icon}{title}</span>
    );

    return (
        <Page>
          <PageHeader
            eyebrow="Teacher Operations"
            title="Add QA Audit"
            subtitle="Score a teacher's session. Every field is required; the total can't exceed 100."
            actions={
              <Button variant="secondary" icon={<ArrowLeft size={16} aria-hidden />} onClick={() => navigate("/pages/qa-policy")}>
                Back
              </Button>
            }
          />

          <div className="qa-form">
            <Card title={sectionTitle(<User size={18} aria-hidden />, 'Basic Information')}>
              <div className="qa-grid">
                <div className="qa-inline">
                  <Field label="Search Teacher">
                    {(ctl) => (
                      <SearchInput
                        {...ctl}
                        name="searchTeacher"
                        value={searchQuery} // State for the search query
                        onChange={(e) => setSearchQuery(e.target.value)} // Update search query
                      />
                    )}
                  </Field>
                  <Button variant="secondary" onClick={handleSearch}>Search</Button>
                </div>
                <Field label="Teacher Name">
                  {(ctl) => <TextInput {...ctl} disabled type="text" name="teacherName" value={formData.teacherName} onChange={handleChange} />}
                </Field>
                <Field label="Teacher Category">
                  {(ctl) => <TextInput {...ctl} type="text" name="teacherCategory" value={formData.teacherCategory} onChange={handleChange} />}
                </Field>
                <Field label="Student Name">
                  {(ctl) => <TextInput {...ctl} type="text" name="studentName" value={formData.studentName} onChange={handleChange} />}
                </Field>
                <Field label="Age Group">
                  {(ctl) => (
                    <Select
                      {...ctl}
                      name="ageGroup"
                      onChange={handleInputChange}
                      options={[
                        { value: '', label: 'Select Age Group' },
                        ...(ageGroups || []).map((ageGroup: any) => ({ value: ageGroup.name, label: ageGroup.name })),
                      ]}
                    />
                  )}
                </Field>
                <Field label="Course">
                  {(ctl) => (
                    <Select
                      {...ctl}
                      name="course"
                      onChange={handleInputChange}
                      options={[
                        { value: '', label: 'Select a course' },
                        ...(courseOptions || []).map((c: any) => ({ value: c.value, label: c.value })),
                      ]}
                    />
                  )}
                </Field>
                <Field label="Session Date">
                  {(ctl) => <TextInput {...ctl} type="date" name="sessionDate" value={formData.sessionDate} onChange={handleChange} />}
                </Field>
                <Field label="Audit Date">
                  {(ctl) => <TextInput {...ctl} type="date" name="auditDate" value={formData.auditDate} onChange={handleChange} />}
                </Field>
                <Field label="Feedback Status">
                  {(ctl) => <TextInput {...ctl} name="feedbackStatus" value={formData.feedbackStatus} type="text" onChange={handleChange} />}
                </Field>
                <Field label="Feedback Link">
                  {(ctl) => <TextInput {...ctl} onChange={handleChange} name="feedbackLink" type="text" value={formData.feedbackLink} />}
                </Field>
                <Field label="Observation" className="qa-grid__full">
                  {(ctl) => (
                    <textarea
                      {...ctl}
                      className="ds-input qa-textarea"
                      onChange={handleChange as unknown as React.ChangeEventHandler<HTMLTextAreaElement>}
                      name="observation"
                      value={formData.observation}
                    />
                  )}
                </Field>
              </div>
            </Card>

            {scoreSections.map((section) => (
              <Card key={section.title} title={sectionTitle(section.icon, section.title)}>
                <div className="qa-grid">
                  {section.fields.map((f) => {
                    const value = scoreValue(f.name);
                    return (
                      <Field key={f.name} label={f.label} error={f.validate ? scoreError(value) : undefined}>
                        {(ctl) => (
                          <TextInput
                            {...ctl}
                            type={f.type}
                            name={f.name} // Use dot notation for nested state
                            value={value}
                            onChange={handleChange}
                            placeholder="Enter 0 to 5"
                          />
                        )}
                      </Field>
                    );
                  })}
                  {section.title === 'Time' && (
                    <Field label="Observation">
                      {(ctl) => (
                        <TextInput
                          {...ctl}
                          onChange={handleChange}
                          type="text"
                          name="observation" // Top-level state
                          value={formData.observation}
                        />
                      )}
                    </Field>
                  )}
                </div>
              </Card>
            ))}

            <Card>
              <div className="qa-form-footer">
                {/* Total Score Display */}
                <TotalScoreDisplay />
                <Button variant="primary" onClick={handleSubmit} loading={isLoading}>
                  Save
                </Button>
              </div>
            </Card>
          </div>

          <Modal isOpen={isModalOpen} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>Select Teacher</ModalHeader>
            <ModalBody className="qa-modal-body">
              {teachers.length === 0 ? (
                <EmptyState title="No teachers found" description="Try a different spelling of the teacher's name." />
              ) : (
                <ul className="qa-picker">
                  {teachers.map((teacher) => (
                    <li key={teacher.credentialId} className="qa-picker__item">
                      <input
                        id={`qa-add-teacher-${teacher.credentialId}`}
                        className="levelChk"
                        type="radio"
                        name="selectedTeacher"
                        value={teacher.teacherName}
                        checked={selectedTeacher === teacher.teacherName} // Track selected teacher
                        onChange={() => {
                          setSelectedTeacher(teacher.teacherName);
                          setSelectedTeacherId(teacher.teacherId); // Store teacher ID
                        }}
                      />
                      <label htmlFor={`qa-add-teacher-${teacher.credentialId}`}>{teacher.teacherName}</label>
                    </li>
                  ))}
                </ul>
              )}
            </ModalBody>
            <ModalFooter>
              <Button variant="secondary" onClick={toggleModal}>Cancel</Button>
              <Button variant="primary" onClick={handleAddTeacher}>Select and Add Teacher</Button>
            </ModalFooter>
          </Modal>
        </Page>
    );
};

export default AddQaList;